/**
 * Ingredients page — nav interactions
 * - Toggles the mobile anchor-link menu
 * - Adds an "is-active" class to the nav link matching the section in view
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var navs = document.querySelectorAll('[data-ti-nav]');

    navs.forEach(function (nav) {
      var toggle = nav.querySelector('[data-ti-nav-toggle]');
      var links = nav.querySelector('[data-ti-nav-links]');

      if (toggle && links) {
        toggle.addEventListener('click', function () {
          var isOpen = links.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }

      var anchorLinks = nav.querySelectorAll('a[href^="#"]');
      if (!anchorLinks.length || !('IntersectionObserver' in window)) return;

      var targets = [];
      anchorLinks.forEach(function (link) {
        var id = link.getAttribute('href').slice(1);
        var target = id ? document.getElementById(id) : null;
        if (target) targets.push({ link: link, target: target });
      });

      if (!targets.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var match = targets.find(function (t) { return t.target === entry.target; });
            if (!match) return;
            if (entry.isIntersecting) {
              anchorLinks.forEach(function (l) { l.classList.remove('is-active'); });
              match.link.classList.add('is-active');
            }
          });
        },
        { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
      );

      targets.forEach(function (t) { observer.observe(t.target); });

      // Close mobile menu after a link is tapped
      if (links) {
        anchorLinks.forEach(function (link) {
          link.addEventListener('click', function () {
            links.classList.remove('is-open');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          });
        });
      }
    });
  });
})();
